import { render, staticRenderFns } from "./playcard.vue?vue&type=template&id=a1651568&lang=pug"
import script from "./playcard.vue?vue&type=script&lang=js"
export * from "./playcard.vue?vue&type=script&lang=js"
import style0 from "./playcard.vue?vue&type=style&index=0&id=a1651568&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports